{
    "dataMessage": "Data with our intuitive Dashboard",
    "visualise": "Visualise your Institute’s",
    "registerInstitute": "Register Your Institute",
    "bluewingsMessage": "Register your Institute with Bluewings",
    "instituteName": "Institute Name",
    "placeHolderInstitute": "Enter your Institute Name",
    "mobileNumber": "Mobile Number ",
    "placeHolderMobile": "Enter your Mobile Number",
    "emailId": "Email Id",
    "placeHolderEmail": "Enter your Email Id",
    "urlInstitution": "Institute URL",
    "placeHolderUrl": "Enter your URL",
    "postfix": ".bluewings.in",
    "urlSuggestion": "URL Suggestions:",
    "continue": "Continue",
    "already": "Already registered?",
    "login": "Login",
    "help": "Help ?",
    "instituteNameError": "Please enter valid institute name",
    "instituteTypeError": "You must select at least one item",
    "validNumber": "Please enter valid mobile number",
    "validEmail": "Please enter valid email id",
    "helpLink": "https://bluewings.in/",
    "validName": "Please enter your valid name",
    "validLocality": "Please enter valid locality",
    "addressError": "please enter valid address",
    "validPinCode": "Please enter valid pinCode",
    "plan": "Plan, publish,",
    "publish": "send reminders, and collect fees.",
    "seamless": "Seamlessly manage staffs and students",
    "userFriendly": "with our user friendly platform.",
    "emailOtp": "Please enter the OTP sent to the registered mail id.",
    "mobileOtp": "Please enter the OTP sent to the registered mobile number.",
    "otpVerification": "OTP Verification",
    "resendOtp": "Resend otp",
    "verify": "Verify",
    "back": " Go Back",
    "attempt": "attempts left",
    "sec": "sec",
    "in": "in",
    "errorMessage": "Oops ! Something went wrong",
    "defaultCountryCode": "+91",
    "urlErrorFirst": "Please enter url",
    "urlErrorSecond": "Please enter valid url",
    "errorCode": "error",
    "successCode": "success",
    "localhost": "localhost",
    "localHostLogin": "http://app.localhost:4200",
    "bluewingsUrl": "app.bluewings.in",
    "moreAboutInstitute": "Tell us more about your Institute.",
    "instituteLocated": "Where is your Institute located?",
    "placeHolderInstituteType": "Select Institute Type",
    "instituteType": "Institute Type",
    "yourName": "Your Name",
    "placeHolderName": "Enter your name",
    "locality": "Locality",
    "placeHolderLocality": "Enter Locality",
    "placeHolderAddress": "Enter Address",
    "address": "Address",
    "placeHolderPinCode": "Enter Pin Code",
    "pinCode": "Pin Code",
    "country": "Country",
    "placeHolderCountry": "Select Country",
    "state": "State",
    "placeHolderSelectState": "Select State",
    "validCountry": "Please select country",
    "validState": "Please select state",
    "father": "Father",
    "mother": "Mother",
    "student": "Student",
    "guardian": "Guardian",
    "staff": "Staff",
    "underVerification": "Under Verification",
    "underVerificationMessage": "Your registration has been successfully completed. <br>Please wait while it is being verified.",
    "okay": "okay",
    "underVerificationMessagesecond": "Your profile is under verification",
    "teamReviewingProfile": "Our team is reviewing your profile to ensure a<br>smooth onboarding experience. While we work on that,<br>we'd love to learn a little more about you.",
    "notInterested": "Not Interested",
    "pkInstituteTypeId": "pkInstituteTypeId",
    "instituteTypeName": "instituteTypeName",
    "token": "token",
    "migrationNotAllowed": "Migration not allowed",
    "logout": "Logout",
    "logoutMessage": "Are you sure you want to logout?",
    "cancel": "Cancel",
    "enterYourAnswer": "Enter your answer",
    "defaultCurrencyType": "INR",
    "currency" :"currency"
}